export default __webpack_public_path__ + "static/media/delivery_state.1fc81908.png";